<template>
  <div>
    <v-card-title style="border-radius: 15px;"
    :class="$vuetify.theme.dark ? 'BuilderGradient justify-start mediumoverline' : 'BoldBuilderGradient justify-start mediumoverline'">
        <v-avatar size="80" class="mx-1">
             <v-img contain src="@/assets/BnPFullLogo.png"/>
        </v-avatar>
      Subscriptions for your Suite
      <v-spacer>
      </v-spacer>
       {{CurrencyFormatter(SuiteTotal,$store.state.DefaultCurrency.Currency)}}
      </v-card-title>
       <v-card v-for="mod in BaseSubscriptions" :key="mod.itemObjKey" elevation="0" class="siteconfigcard SoftBuilderGradient">
        <v-card-title class="mediumoverline">
          {{mod.Name}}
          <v-spacer>
          </v-spacer><v-icon large>{{mod.Icon}}</v-icon>
      </v-card-title>
      <v-card-text >
          <v-list class="transparent">
              <v-list-item>
                  <v-list-item-content>
                  {{mod.Name}}
                  </v-list-item-content>
                  <v-list-item-content>
                  {{mod.Date}}
                  </v-list-item-content>
                  <v-list-item-content>
                     {{CurrencyFormatter(mod.Price,$store.state.DefaultCurrency.Currency)}}
                  </v-list-item-content>
                  <v-list-item-actions>
                       <v-btn @click="DeactivatePlugin(mod)" v-if="mod.Active" large outlined class="BoldBuilderGradient" color="white" style="border-color: black;">Deactivate</v-btn>
                      <v-btn @click="ActivatePlugin(mod)" v-if="!mod.Active"  large outlined color="white" style="border-color: black;">Activate</v-btn>
                  </v-list-item-actions>
              </v-list-item>
              <v-list-item v-for="plug in mod.Plugins" :key="plug.itemObjKey">
                   <v-list-item-content>
                  {{plug.Name}}
                  </v-list-item-content>
                   <v-list-item-content>
                   {{plug.Date}}
                  </v-list-item-content>
                  <v-list-item-content>
                     {{CurrencyFormatter(plug.Price,$store.state.DefaultCurrency.Currency)}}
                  </v-list-item-content>
                   <v-list-item-actions>
                      <v-btn @click="DeactivatePlugin(plug)" v-if="plug.Active"  class="BoldBuilderGradient" large outlined color="white" style="border-color: black;">Deactivate</v-btn>
                      <v-btn @click="ActivatePlugin(plug)" v-if="!plug.Active"  large outlined color="white" style="border-color: black;">Activate</v-btn>
                  </v-list-item-actions>
              </v-list-item>
              <v-list-item class="mediumoverline justify-end">
                   {{CurrencyFormatter(mod.Total,$store.state.DefaultCurrency.Currency)}}
              </v-list-item>
          </v-list>
      </v-card-text>
      </v-card>
      <v-card v-for="app in AppSubscriptions" :key="app.itemObjKey" elevation="0" class="siteconfigcard SoftBuilderGradient">
        <v-card-title class="mediumoverline">
          {{app.Name}}<v-spacer>
          </v-spacer>
          <v-icon large>{{app.Icon}}</v-icon>
      </v-card-title>
      <v-card-subtitle>
        {{app.TotalPlugins}} Plugins
      </v-card-subtitle>
      <v-card-text >
          <v-list class="transparent" v-if="app.Plugins && app.Plugins.length > 0">
              <v-list-item v-for="plug in app.Plugins" :key="plug.itemObjKey">                
                   <v-list-item-content>
                  {{plug.Name}}
                  </v-list-item-content>
                   <v-list-item-content>
                   {{plug.Date}}
                  </v-list-item-content>
                  <v-list-item-avatar>
                    <v-tooltip bottom max-width="200">
                        <template v-slot:activator="{ on, attrs }">
                        <v-icon :color="plug.LevelColor" v-on="on" v-bind="attrs">{{plug.LevelIcon}}
                        </v-icon>
                    </template>
                        {{plug.LevelDescription}}
                    </v-tooltip>
                    </v-list-item-avatar>
                  <v-list-item-content>
                     {{CurrencyFormatter(plug.Price,$store.state.DefaultCurrency.Currency)}}                     
                  </v-list-item-content>                   
                   <v-list-item-actions>
                       <v-btn @click="DeactivatePlugin(plug,app)" v-if="plug.Active"  class="BoldBuilderGradient" large outlined color="white" style="border-color: black;">Deactivate</v-btn>
                      <v-btn @click="ActivatePlugin(plug,app)" v-if="!plug.Active"  large outlined color="white" style="border-color: black;">Activate</v-btn>
                  </v-list-item-actions>
              </v-list-item>                
          </v-list>
          <v-list-item class="mediumoverline justify-end">
                   {{CurrencyFormatter(app.Total,$store.state.DefaultCurrency.Currency)}}
              </v-list-item>
      </v-card-text>
      </v-card>
      <v-card elevation="0" class="siteconfigcard SoftBuilderGradient">
        <v-card-subtitle class="mediumoverline">
          Recent Activity
      </v-card-subtitle>
      <v-card-text >
         Per Module
      </v-card-text>
      </v-card>
      
  </div>
</template>

<script>
import firebase from 'firebase';
import db from '@/main'
import axios from 'axios'
import format from 'date-fns/format'
import InfoSheet from '@/components/WebPages/RenderComponents/InfoSheetReadOnly';
export default {
    props: ['System','SystemEntities','Record'],
    components: {InfoSheet},
    data() {
        return {
            Plugins: [],
            AppsDataBase: [],
            SystemTickets: [],
            RoadmapItems: [],
            elmnt:  {	
                						
                RowColor: '#00ffff',									
                Name: 'Info Sheet',									
                ShowComponents: true,									
                Icon: 'mdi-alert',									
                Title: 'About',									
                Description: `Add the Ability to import Platform Features`,									
                MarginTop: 0,									
                MarginBottom: 0,									
                MarginLeft: 0,									
                MarginRight: 0,									
                Color: 'red',	
                Elevation: 6,
                AlertIcon: 'mdi-alert',	
                BorderPosition: 'top',
                ColoredBorder: true,							
                FontColor :{									
                        hex: '#000000'									
                },									
                HeaderColor: {									
                    hex: '#000000'									
                },									
                FlexXLRG:3,									
                FlexLarge: 3,									
                FlexMedium: 4,									
                FlexSmall: 12,									
                FlexXSmall: 12,									
                Cols: 12,	
                Progress: 0,
                // Prominent: true								
            },	
        }
    },	
    computed:{
        PluginDataBase(){
            let obj = {}
            this.Plugins.map(plug => {
                //console.log(plug)
                obj[plug.id] = plug
            })
            return obj
        },
        SuiteTotal(){
            let appstotal = this.AppSubscriptions.map(plug => {
                    return plug.Total
                })
                .reduce((a, b) => a + b, 0)
            let modstotal = this.BaseSubscriptions.map(plug => {
                    return plug.Total
                })
                .reduce((a, b) => a + b, 0)
                return appstotal+modstotal
        },
        AppSubscriptions(){
            return this.AppsDataBase.map(app => {
                let appobj = Object.assign({},app)
                appobj.TotalPlugins = app.Plugins.length
                appobj.Plugins = app.Plugins.map(plug => {
                    let plugobj = Object.assign({},this.RAPlugins.find(obj => obj.id === plug.id))
                    plugobj.Date = this.TimestampFormatterSTRINGDayText(new Date)
                    return plugobj
                }).map(plug => {
                    let plugobj = Object.assign({},plug)
                    plugobj.Active = app.Plugins.find(obj => obj.id === plug.id).Active
                    return plugobj
                })
                .map(plug => {
                    if(plug.Level.Name !== 'App'){
                        plug.Price = 0
                        plug.LevelIcon = 'mdi-cash-refund'
                        plug.LevelColor = 'blue'
                        plug.LevelDescription = 'No App Charge - Charged on Suite Level'
                    }
                    else{
                        plug.LevelIcon = 'mdi-cash-check'
                        plug.LevelColor = 'green'
                        plug.LevelDescription = 'App Charge as indicated'
                    }
                    return plug
                })
                appobj.Total = appobj.Plugins.map(plug => {
                    return plug.Price
                })
                .reduce((a, b) => a + b, 0)
                return appobj
            })
        },
        BaseSubscriptions(){
            let modules = this.ActivePlugins.filter(plug => {
                return plug.Module_Category && plug.Module_Category.Name === 'Module'
            })
            let modulenames = modules.map(mod => {
                return mod.Name
            })
            let nomodules = this.ActivePlugins.filter(plug => {
                return plug.Module_Category && plug.Module_Category.Name !== 'Module'
            }).filter(plug => {
                    return plug.Module_Category && !modulenames.includes(plug.Module_Category.Name)
                })
            return modules.map(mod => {
                let modobj = Object.assign({},mod)
                modobj.Date = this.TimestampFormatterSTRINGDayText(new Date)
                modobj.Plugins = this.ActivePlugins.filter(plug => {
                    return plug.Module_Category && plug.Module_Category.Name === modobj.Name
                }).map(plug => {
                    let plugobj = Object.assign({},plug)
                    plugobj.Date = this.TimestampFormatterSTRINGDayText(new Date)
                    return plugobj
                }) 
                 modobj.Total = 0
                 if(modobj.Active){
                     modobj.Total = modobj.Price
                 }
                return modobj
            }).concat(nomodules.map(mod => {
                let modobj = Object.assign({},mod)
                modobj.Date = this.TimestampFormatterSTRINGDayText(new Date)
                modobj.Plugins = this.ActivePlugins.filter(plug => {
                    return plug.Module_Category && plug.Module_Category.Name === modobj.Name
                }).map(plug => {
                    let plugobj = Object.assign({},plug)
                    plugobj.Date = this.TimestampFormatterSTRINGDayText(new Date)
                    return plugobj
                })             
                 modobj.Total = 0
                 if(modobj.Active){
                     modobj.Total = modobj.Price
                 }
                return modobj
            }))
        },
        ActivePlugins(){
          return this.RAPlugins.filter(plug => {
              return this.PluginDataBase[plug.id]
              // && this.PluginDataBase[plug.id].Active
          }).map(plug => {
              let plugobj = Object.assign({},plug)
              plugobj.Active = this.PluginDataBase[plug.id].Active
              return plugobj
          })
      },
       UnPaidPlugins(){
          return this.RAPlugins.filter(plug => {
              return this.PluginDataBase[plug.id] && !this.PluginDataBase[plug.id].Active
          })
      },
      PurchasablePlugins(){
          return this.RAPlugins.filter(plug => {
              return !this.PluginDataBase[plug.id] && plug.Strictly_One_Purchase || !plug.Strictly_One_Purchase
          })
      },
        RAPlugins(){
          return this.$store.state.RAPlugins
        },
         ActiveDB(){
            return db
        },
        IncompleteRoadmapItems(){
            return this.RoadmapItems.filter(item => {
                return item.Status && item.Status.Name !== 'InActive'
            })
        },
        OpenSystemTickets(){
            return this.SystemTickets.filter(ticket => {
                return ticket.Status && ticket.Status.Name !== 'InActive'
            })
        },
        HighlightedAlertElements(){
            let items = [
                {Title: 'Incomplete System Tickets',Array: 'OpenSystemTickets', TableName: 'System Tickets', TablePath: 'SystemTickets',IncompleteName: 'Open'},
                {Title: 'Incomplete Roadmap Items',Array: 'IncompleteRoadmapItems', TableName: 'Roadmap Items', TablePath: 'Roadmap',IncompleteName: 'Incompleted'},
            ]
            items.map(item => {
               if(this[item.Array] && this[item.Array].length > 0){
                        item.Description = 'You have a total of '+this[item.Array].length+' '+item.IncompleteName+' '+item.TableName+'. View them now?'
                        item.Color = 'red'
                        item.AlertIcon = 'mdi-alert'
                        item.HasActionButton = true
                        item.RoutePath = '/'+item.TablePath
                    }
                    else if(!this[item.Array] || this[item.Array] && this[item.Array].length === 0){
                        item.Description = 'No '+item.TableName+' '+item.IncompleteName+'.'
                        item.Color = 'green'
                        item.AlertIcon = 'mdi-check'
                    }
                return item
            })
            return items.map(item => {
                let elmnt = Object.assign({},this.elmnt)
                elmnt.Title = item.Title
                elmnt.Description = item.Description
                elmnt.Color = item.Color
                elmnt.AlertIcon = item.AlertIcon
                if(item.HasActionButton){
                    elmnt.HasActionButton = item.HasActionButton
                    elmnt.RoutePath = item.RoutePath
                }
                return elmnt
            })
        },
        userLoggedIn () {
        return this.$store.getters.user
        },
        userIsAdmin () {
            return this.$store.state.IsAdmin
        },
        WindowHeight(){
            return window.innerHeight
        },
        SocialItemInteractMethod(){
        return this.$store.state.SocialItemInteractMethod
        },
        SocialItemInteractMethodProp(){
            return this.$store.state.SocialItemInteractMethodProp
        },
    },
    watch: {
        SocialItemInteractMethod(v){   
        let acceptedmethods = []   
        if(v && acceptedmethods.includes(v)){
          if(this.SocialItemInteractMethodProp){
            this[this.SocialItemInteractMethod](this.SocialItemInteractMethodProp)
            if(this.SocialItemInteractMethod === 'ActivateSelectedElement'){
              this.SingleRecordNavMenuItem = ''
            }
            this.$store.commit('SetSocialItemInteractMethodProp','') 
            this.$store.commit('SetSocialItemInteractMethod','')
          }
          else{ 
            this[this.SocialItemInteractMethod]()
            this.$store.commit('SetSocialItemInteractMethodProp','') 
            this.$store.commit('SetSocialItemInteractMethod','')
          }          
        }
      },
    },
    created(){
        //console.log(this.Record,this.Plugins,this.AppsDataBase)
        this.GetSuiteApps(db.collection('systems').doc(this.Record.id).collection('apps'))
        this.GetSuitePlugins(db.collection('systems').doc(this.Record.id).collection('plugins'),this)
    },
    methods:{
        GetSuiteApps(query){
            query.onSnapshot(res =>{
                const changes = res.docChanges();
                changes.forEach((change,i) => {
                    if (change.type === 'added') {
                    let appobj = {
                        ...change.doc.data(),
                            id: change.doc.id
                    }
                    if(!appobj.Plugins){
                        appobj.Plugins = []
                    }
                    this.GetSuitePlugins(query.doc(appobj.id).collection('plugins'),appobj)
                    this.AppsDataBase.push(appobj)
                    }
                    else if (change.type === 'modified') {
                    let appobj = {
                        ...change.doc.data(),
                            id: change.doc.id
                    }
                    let oncheck = this.AppsDataBase.find(obj => obj.id === appobj.id)
                    if(oncheck){
                        let index = this.AppsDataBase.indexOf(oncheck)
                        appobj.Plugins = oncheck.Plugins
                        this.AppsDataBase.splice(index,1,appobj)
                    }
                    }
                    else if (change.type === 'removed') {
                    let appobj = {
                        ...change.doc.data(),
                            id: change.doc.id
                    }
                    let oncheck = this.AppsDataBase.find(obj => obj.id === appobj.id)
                    if(oncheck){
                        let index = this.AppsDataBase.indexOf(oncheck)
                        this.AppsDataBase.splice(index,1)
                    }
                    }
                })
            })
        },
        GetSuitePlugins(query,parent){
            query.onSnapshot(res =>{
                const changes = res.docChanges();
                changes.forEach((change,i) => {
                    if (change.type === 'added') {
                    let plugobj = {
                        ...change.doc.data(),
                            id: change.doc.id
                    }
                    parent.Plugins.push(plugobj)
                    }
                    else if (change.type === 'modified') {
                    let plugobj = {
                        ...change.doc.data(),
                            id: change.doc.id
                    }
                    let oncheck = parent.Plugins.find(obj => obj.id === plugobj.id)
                    if(oncheck){
                        let index = parent.Plugins.indexOf(oncheck)
                        parent.Plugins.splice(index,1,plugobj)
                    }
                    }
                    else if (change.type === 'removed') {
                    let plugobj = {
                        ...change.doc.data(),
                            id: change.doc.id
                    }
                    let oncheck = parent.Plugins.find(obj => obj.id === plugobj.id)
                    if(oncheck){
                        let index = parent.Plugins.indexOf(oncheck)
                        parent.Plugins.splice(index,1)
                    }
                    }
                })
            })
        },
        DeactivatePlugin(plug,appobj){
            let path = ''
            if(appobj){
                path = db.collection('systems').doc(this.Record.id).collection('apps').doc(appobj.id).collection('plugins').doc(plug.id)
            }
            else{
                path = db.collection('systems').doc(this.Record.id).collection('plugins').doc(plug.id)
            }
            path.update({
                Active: false
            })
        },
        ActivatePlugin(plug,appobj){
            let path = ''
            if(appobj){
                path = db.collection('systems').doc(this.Record.id).collection('apps').doc(appobj.id).collection('plugins').doc(plug.id)
            }
            else{
                path = db.collection('systems').doc(this.Record.id).collection('plugins').doc(plug.id)
            }
            path.update({
                Active: true
            })
        },
        GetAppPlugins(appobj){
            db.collection('systems').doc(this.Record.id).collection('apps').doc(appobj.id).collection('plugins').onSnapshot(res =>{
                const changes = res.docChanges();
                changes.forEach((change,i) => {
                    if (change.type === 'added') {
                    let plugobj = {
                        ...change.doc.data(),
                            id: change.doc.id
                    }
                    appobj.Plugins.push(plugobj)
                    }
                    else if (change.type === 'modified') {
                    let plugobj = {
                        ...change.doc.data(),
                            id: change.doc.id
                    }
                    let oncheck = appobj.Plugins.find(obj => obj.id === plugobj.id)
                    if(oncheck){
                        let index = appobj.Plugins.indexOf(oncheck)
                        appobj.Plugins[index] = plugobj
                    }
                    }
                })
            })
        },
        TimestampFormatterSTRINGDayText(d){
       
        var months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
        var days = [{Longtext: "Sunday",Shorttext: 'Sun'},{Longtext: "Monday",Shorttext: 'Mon'},{Longtext: "Tuesday",Shorttext: 'Tue'},{Longtext: "Wednesday",Shorttext: 'Wed'}, {Longtext: "Thursday",Shorttext: 'Thu'}, {Longtext: "Friday",Shorttext: 'Fri'},{Longtext: "Saturday",Shorttext: 'Sat'}]
      
        var hr = d.getHours();
       
        var min = d.getMinutes();
        if (min < 10) {
            min = "0" + min;
        }
        if(hr < 10){
          hr = "0"+hr
        }

        var daytext = days[d.getDay()].Longtext
        var date = d.getDate();
        var month = months[d.getMonth()];
        var year = d.getFullYear();
        // 2020-03-15 09:00'
        let finaldate = daytext+' '+date+', '+month+', '+year

        return finaldate
      },
        CurrencyFormatter(value,currency){
        const currencyformatter = this.PrepareCurrency(currency)
        let formalformat = currencyformatter.format(value)
        return formalformat
        },
        PrepareCurrency(currency){			
        let currobj = this.$store.state.Currencies.find(obj => obj.Currency === currency)
        let lang = this.$store.state.DefaultCurrency.LangForm
        if(currobj){
            lang = currobj.LangForm
        }
        return new Intl.NumberFormat(lang, {			
                style: 'currency',			
                currency: currency,			
                minimumFractionDigits: 2			
            })
        
        },
        GetArrayData(query,array){
            query.onSnapshot(res => {
                const changes = res.docChanges();
                changes.forEach(change => {
                    if (change.type === 'added') {
                    let recordobj = {
                        ...change.doc.data(),
                        id: change.doc.id
                    }
                    if(array === 'GroupLandingPageViews'){                        
                        recordobj.Page_Obj = {
                            id: recordobj.Path.split('/')[3].split(' ').join('_'),
                            Page_Name: recordobj.Path.split('/')[3]
                        }
                        recordobj.Group_Obj = {
                            id: recordobj.RecordId,
                            Group_Name: recordobj.RecordId.split('_').join(' ')
                        }
                        //console.log('GroupLandingPageViews',recordobj)
                    }
                    if(array === 'PublicPageViews' || array === 'SocialPageViews'){
                        recordobj.Page_Obj = {
                            id: recordobj.RecordId,
                            Page_Name: recordobj.RecordId.split('_').join(' ')
                        }
                        if(recordobj.User && recordobj.Userid){
                            recordobj.User_Obj = {
                                Full_Name: recordobj.User,
                                id: recordobj.Userid
                            }
                        }
                    }
                    if(array === 'LandingPageViews'){
                        recordobj.Page_Obj = {
                            id: recordobj.RecordId,
                            Page_Name: recordobj.RecordId.split('_').join('')
                        }
                        if(recordobj.User && recordobj.Userid){
                            recordobj.User_Obj = {
                                Full_Name: recordobj.User,
                                id: recordobj.Userid
                            }
                        }
                    }
                    this[array].push(recordobj)
                }
                })
            })
        },
    }
}
</script>

<style>

</style>



